import { useContext } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { authContext } from "../../context/AuthContext";
import DoctorDiagnostico from "../doctor/DoctorDiagnostico";
import DoctorReceta from "../doctor/DoctorReceta";

function CardActionRightMedicalMexico({t, cita}){
    const {auth} = useContext(authContext)
{console.log('Cita card',cita)}
    return (
        <Card className="shadow-1">
            <Card.Body>
                <Tabs defaultActiveKey="receta" className="tabs-conference" transition={false}>
                    <Tab eventKey="receta" title={t('receta')}>
                        <DoctorReceta 
                            appointmentReceta={cita?.receta}
                            citaID={cita.id}
                            auth={auth} 
                        />
                    </Tab>
                    <Tab eventKey="diagnostico" title={t('diagnostico')}>
                        <DoctorDiagnostico 
                            citaID={cita.id}
                            auth={ auth } 
                            fieldIndex = { 1 }
                            disease={ cita?.disease }
                            idSpeciality={Number(cita?.speciality.id)}
                        />
                        <DoctorDiagnostico 
                            citaID={cita.id}
                            auth={ auth } 
                            fieldIndex = { 2 }
                            disease={ cita?.diagnostico2 }
                            idSpeciality={Number(cita?.speciality.id)}
                        />
                        <DoctorDiagnostico 
                            citaID={cita.id}
                            auth={ auth } 
                            fieldIndex = { 3 }
                            disease={ cita?.diagnostico3 }
                            idSpeciality={Number(cita?.speciality.id)}
                        />
                    </Tab>
                </Tabs>
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(CardActionRightMedicalMexico)